import React, { Children } from 'react';
import { Database, Users, Building2, FileText, Shield, Target } from 'lucide-react';
import { motion } from 'framer-motion';
const fadeInUp = {
  initial: {
    opacity: 0,
    y: 20
  },
  animate: {
    opacity: 1,
    y: 0
  },
  transition: {
    duration: 0.6
  }
};
const staggerContainer = {
  animate: {
    transition: {
      staggerChildren: 0.15
    }
  }
};
export function WhatWeDoSection() {
  return <section className="bg-black py-24" data-id="element-156">
      <div className="max-w-7xl mx-auto px-6 lg:px-12" data-id="element-157">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-158">
          <h2 className="text-3xl md:text-4xl lg:text-5xl text-white font-medium mb-6" data-id="element-159">
            How We Help
          </h2>
        </motion.div>
        <motion.div className="grid md:grid-cols-3 gap-8 mb-16" variants={staggerContainer} initial="initial" whileInView="animate" viewport={{
        once: true
      }} data-id="element-160">
          {[{
          icon: Target,
          title: 'Discover',
          desc: 'Surface duplicate spend, missed billing, rework, and compliance risk'
        }, {
          icon: Database,
          title: 'Align',
          desc: 'Build golden records & roadmaps across providers, patients, payers, and locations'
        }, {
          icon: Shield,
          title: 'Deploy',
          desc: 'We roll it out, hands-on, so your teams stay focused on care delivery'
        }].map((item, index) => <motion.div key={index} variants={fadeInUp} className="bg-white/5 border border-white/10 rounded-2xl p-8" data-id="element-161">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-purple-500 to-cyan-500 flex items-center justify-center mb-6" data-id="element-162">
                <item.icon className="w-6 h-6 text-white" data-id="element-163" />
              </div>
              <h3 className="text-xl font-semibold text-white mb-4" data-id="element-164">
                {item.title}
              </h3>
              <p className="text-white/70 leading-relaxed" data-id="element-165">{item.desc}</p>
            </motion.div>)}
        </motion.div>
        <motion.div className="grid md:grid-cols-5 gap-6 mb-12" variants={staggerContainer} initial="initial" whileInView="animate" viewport={{
        once: true
      }} data-id="element-166">
          {[{
          icon: Users,
          label: 'Provider Data'
        }, {
          icon: Users,
          label: 'Patient/Member Data'
        }, {
          icon: Building2,
          label: 'Locations & Networks'
        }, {
          icon: FileText,
          label: 'Claims/Billing'
        }, {
          icon: Shield,
          label: 'Compliance & Reporting'
        }].map((item, index) => <motion.div key={index} variants={fadeInUp} className="bg-white/5 border border-white/10 rounded-xl p-6 text-center" data-id="element-167">
              <item.icon className="w-8 h-8 text-white/70 mx-auto mb-3" data-id="element-168" />
              <p className="text-sm text-white/70" data-id="element-169">{item.label}</p>
            </motion.div>)}
        </motion.div>
        <motion.div className="bg-gradient-to-br from-purple-500/10 to-cyan-500/10 border border-white/10 rounded-2xl p-8 lg:p-12 text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} whileHover={{
        scale: 1.01
      }} data-id="element-170">
          <div className="max-w-3xl mx-auto" data-id="element-171">
            <div className="w-16 h-16 rounded-full bg-gradient-to-br from-purple-500 to-cyan-500 flex items-center justify-center mx-auto mb-6" data-id="element-172">
              <Database className="w-8 h-8 text-white" data-id="element-173" />
            </div>
            <h3 className="text-2xl font-semibold text-white mb-4" data-id="element-174">
              One Source of Truth
            </h3>
            <p className="text-lg text-white/80 leading-relaxed" data-id="element-175">
              We don't just design strategy. We do the messy work—cleaning,
              aligning, and syncing your data—so your clinicians, finance, and
              ops teams run on the same trusted numbers.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}